import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser"
import * as opt from "lib/opt"

export function GetMsalAccount(i: IPublicClientApplication): Opt<AccountInfo> {
	return opt.FromNullable(
		i.getActiveAccount() ||
			i
				.getAllAccounts()
				.First()
				.UnwrapOr(null as any)
	)
}
